import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca316278&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ca316278&prod&lang=css"
import style1 from "../../assets/commoon/css/common.css?vue&type=style&index=1&id=ca316278&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca316278",
  null
  
)

export default component.exports